module.exports = "<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/Pages/manage/vendor/vendor.component.html
// module id = ./src/app/Pages/manage/vendor/vendor.component.html
// module chunks = main